import React, { Fragment } from "react";
import PropTypes from "prop-types";

import Form from "../../common/Form";

import Organisator from "./parts/Organisator";
import Contactpersoon from "./parts/Contactpersoon";
import ContactpersoonTijdensActiviteit from "./parts/ContactpersoonTijdensActiviteit";
import Verzekering from "./parts/Verzekering";
import { TochtRedenVanStatus } from "../../../constants/DomainConstants";
import Confirm from "../../common/Confirm";

const OrganisatorForm = (props) => {
    const {
        model,
        onChangeChildModel,
        onSave,
        getError,
        disabled,
        color,
        postcodes,
        gemeenten,
        landen,
        rechtspersoonlijkheidTypes,
        contactpersonen,
        organisatorGegevensUrl,
        validationMessageType,
        showAnbPopup,
        onConfirmAnbPopup
    } = props;

    const mapChangeChild = (childModelName) => {
        return function (event) { onChangeChildModel(event, childModelName); };
    };

    const mapGetChildError = (childModelName) => {
        return function (propertyName) { return getError(propertyName, childModelName); };
    };

    const sharedProps = (childModelName) => {
        const onChange = mapChangeChild(childModelName);
        const getError = mapGetChildError(childModelName);
        return {
            onChange,
            getError,
            disabled
        };
    };

    const hasStep1Status =
        !model.redenVanStatus ||
        model.redenVanStatus === TochtRedenVanStatus.AfgekeurdDoorFedKoepel ||
        model.redenVanStatus === TochtRedenVanStatus.InAfwachtigingVanGoedkeuringDoorFedKoepel;

    const hasStep4Status =
        model.redenVanStatus === TochtRedenVanStatus.InAfwachtigingVanMachtiging ||
        model.redenVanStatus === TochtRedenVanStatus.MachtigingOK ||
        model.redenVanStatus === TochtRedenVanStatus.Gepubliceerd;

        const hasFinalStatus =
		model.redenVanStatus === TochtRedenVanStatus.DoorgestuurdTerGoedkeuring;

    const volledig = !model.validatiestatusses.filter(x => x.volledig === false).length;

    const anbPopupText = volledig ? "Jouw dossier is klaar voor ANB en zal overgemaakt worden" : "Jouw dossier is nog niet klaar voor ANB en zal niet overgemaakt worden.";

    return (
        <Fragment>
            {!showAnbPopup
                ||
                <Confirm
                    message={anbPopupText}
                    title={"Klaar voor ANB?"}
                    callback={onConfirmAnbPopup}
                    confirmText="OK"
                />}
            <Form name="Organisator"
                headerVisible={false}
                leftButtonLabel={model.datumIndiening ? null : "Bewaar"}
                onLeftButtonClick={onSave}
                leftButtonDisabled={disabled}
                color={color}>
                <Organisator
                    hasStep1Status={hasStep1Status}
                    hasFinalStatus={hasFinalStatus}
                    {...sharedProps("organisator")}
                    model={model.organisator}
                    postcodes={postcodes}
                    gemeenten={gemeenten}
                    landen={landen}
                    rechtspersoonlijkheidTypes={rechtspersoonlijkheidTypes}
                    organisatorGegevensUrl={organisatorGegevensUrl}
                    validationMessageType={validationMessageType} />
                <Contactpersoon
                    {...sharedProps("contactpersoon")}
                    model={model.contactpersoon}
                    postcodes={postcodes}
                    gemeenten={gemeenten}
                    landen={landen}
                    contactpersonen={contactpersonen}
                    validationMessageType={validationMessageType} />
                <ContactpersoonTijdensActiviteit
                    hasStep4Status={hasStep4Status}
                    {...sharedProps("contactpersoonTijdensActiviteit")}
                    model={model.contactpersoonTijdensActiviteit}
                    postcodes={postcodes}
                    gemeenten={gemeenten}
                    landen={landen}
                    contactpersonen={contactpersonen}
                    validationMessageType={validationMessageType} />
                <Verzekering
                    disabled={disabled}
                    model={model.verzekerd}
                    validationMessageType={validationMessageType}
                    {...sharedProps("verzekerd")}
                    hasStep4Status={hasStep4Status}
                    hasFinalStatus={hasFinalStatus} />
            </Form>
        </Fragment>);
};

OrganisatorForm.propTypes = {
    model: PropTypes.object,
    onChangeChildModel: PropTypes.func.isRequired,
    onSave: PropTypes.func.isRequired,
    getError: PropTypes.func.isRequired,
    disabled: PropTypes.bool,
    readonly: PropTypes.bool,
    color: PropTypes.string,
    postcodes: PropTypes.array.isRequired,
    gemeenten: PropTypes.array.isRequired,
    landen: PropTypes.array.isRequired,
    rechtspersoonlijkheidTypes: PropTypes.array.isRequired,
    onUploadFiles: PropTypes.func.isRequired,
    onDeleteFile: PropTypes.func.isRequired,
    fileComponents: PropTypes.object.isRequired,
    downloadFileUrl: PropTypes.string.isRequired,
    contactpersonen: PropTypes.array.isRequired,
    organisatorGegevensUrl: PropTypes.string.isRequired,
    bewijsVanVerzekeringFileTypes: PropTypes.object.isRequired,
    validationMessageType: PropTypes.string,
    showAnbPopup: PropTypes.bool.isRequired,
    onConfirmAnbPopup: PropTypes.func.isRequired
};

export default OrganisatorForm;